import { useTranslation } from 'react-i18next';

export const useEditOperationTranslations = () => {
  const { t } = useTranslation();

  return {
    totalFarm: t('totalFarm'),
    totalFarmOperationMsg: t('totalFarmOperationMsg'),
    activateTotalFarm: t('activateTotalFarm'),
    fertilityRx: t('fertilityRx'),
    seedRx: t('seedRx'),
    cropPlanning: t('cropPlanning'),
    keyOutcomeMsg: t('keyOutcomeMsg'),
    highResNutrientScriptMsg: t('highResNutrientScriptMsg'),
    highResVariableRateScriptMsg: t('highResVariableRateScriptMsg'),
    customRxMsg: t('customRxMsg'),
    comprehensiveFieldAnalysisMsg: t('comprehensiveFieldAnalysisMsg'),
    highResSoilFertMsg: t('highResSoilFertMsg'),
    comprehensiveFieldBioMsg: t('comprehensiveFieldBioMsg'),
    howItWorks: t('howItWorks'),
    premiumFeatures: t('premiumFeatures'),
    activeTodayGenerateUnlimitedMsg: t('activeTodayGenerateUnlimitedMsg'),
    analysisOverYear: t('analysisOverYear'),
    executeTargetAnalysisMsg: t('executeTargetAnalysisMsg'),
    percentOfFarmAnalyzedPerYear: t('percentOfFarmAnalyzedPerYear'),
    totalAcres: t('totalAcres'),
    estTotalFarmPrice: t('estTotalFarmPrice'),
    subscriptionCoversAnalysisMsg: t('subscriptionCoversAnalysisMsg'),
    totalFarmActivatedMsg: t('totalFarmActivatedMsg'),
    subscriptionRenewal: t('subscriptionRenewal'),
    package: t('package'),
    acres: t('acres'),
    list: t('list'),
    agency: t('agency'),
    price: t('price'),
    cancel: t('cancel'),
    cancelTotalFarm: t('cancelTotalFarm'),
    cancelTotalFarmMsg: t('cancelTotalFarmMsg'),
    totalFarmCancelledMsg: t('totalFarmCancelledMsg'),
    keepTotalFarm: t('keepTotalFarm'),
    customRx: t('customRx'),
    payAsYouGo: t('payAsYouGo'),
    payAsYouGoMsg: t('payAsYouGoMsg'),
    totalFarmAcres: t('totalFarmAcres'),
    year: t('year'),
    msrp: t('msrp'),
    dealerSelfSample: t('dealerSelfSample'),
    dealerSelfService: t('dealerSelfService'),
    dealerFullService: t('dealerFullService'),
    perYear: t('perYear'),
    seeDealerPrice: t('seeDealerPrice'),
  };
};
